import { Button } from '@/components/ui/button';
import useMixPanel from '@/hooks/useMixPanel';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TOrganizationFAQ } from '@/services/api/organization-api';
import { useFormChooseDatetime } from '@/hooks/business-logic/useFormChooseDatetime';
import NoData from '../../no-data/NoData';
import { Skeleton } from '@/components/ui/skeleton';
import ErrorMessage from '../../error-message/ErrorMessage';
import { BookingByCalendar } from './Calendar';

type Props = {
  form: UseFormReturn<any>; // TODO: Add type
  organization: TOrganizationFAQ;
  serviceId: string;
  isLanding: boolean;
};

const BookingDatePickerFormBody = ({
  form,
  organization,
  serviceId,
  isLanding
}: Props) => {
  const {
    availableDates,
    calendarPaginateNavigation,
    toMonth,
    schedule,
    dateValue,
    continueRef,
    currentStep,
    isError,
    isPending,
    timeIsLoading,
    hasSchedule,
    hasUnavailableSchedule,
    handleDateChange,
    defaultDate,
    findSchedule,
    scrollToContinue,
    removeStep,
    loadStepServicesData
  } = useFormChooseDatetime({ serviceId, form });
  const { t } = useTranslation(['newBooking', 'common']);
  const Mixpanel = useMixPanel();

  // TODO: Remove this constant and use the service type (or something else) to determine if it's by groups or not
  const isByGroups = true;

  const handleOnMonthChange = (date: Date) => {
    const curretMonthPaginated = calendarPaginateNavigation.date;

    if (curretMonthPaginated.getTime() < date.getTime()) {
      calendarPaginateNavigation.goToNextMonth();
    } else {
      calendarPaginateNavigation.goToPreviousMonth();
    }
  };

  if (isPending) {
    return <Skeleton className="h-96 w-full" />;
  }

  if (!availableDates) {
    return <NoData />;
  }

  if (isError) {
    return <ErrorMessage />;
  }

  return (
    <div>
      <h2 className="font-bold mb-6">{t('stepDateTitle')}</h2>
      <BookingByCalendar
        form={form}
        organization={organization}
        availableDates={availableDates}
        toMonth={toMonth}
        schedule={schedule}
        dateValue={dateValue}
        timeIsLoading={timeIsLoading}
        hasSchedule={hasSchedule}
        hasUnavailableSchedule={hasUnavailableSchedule}
        continueRef={continueRef}
        handleDateChange={handleDateChange}
        handleOnMonthChange={handleOnMonthChange}
        defaultDate={defaultDate}
        findSchedule={findSchedule}
        scrollToContinue={scrollToContinue}
        loadStepServicesData={loadStepServicesData}
      />
      {!isLanding ? (
        <div className="flex flex-col gap-3">
          <Button
            ref={continueRef}
            onClick={() =>
              Mixpanel.track('press continue button', {
                screen: 'New Booking'
              })
            }
            type="submit"
          >
            {t('common:continue')}
          </Button>
          <Button
            onClick={() => {
              Mixpanel.track('press go back', {
                screen: 'New Booking'
              });
              removeStep(currentStep);
              loadStepServicesData({
                firstReservationStartTime: undefined
              });
            }}
            variant={'outline'}
          >
            {t('common:goBack')}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default BookingDatePickerFormBody;
